module.exports = __webpack_public_path__ + "img/CatapultTrireme64_ua.beadd07a.webp";